import { Button } from "@rosette/web_components/src/ui/Button.js";


interface TestUser {
    cognitoId: string;
    label: string;
}


const testUsers: TestUser[] = [
    { cognitoId: "00000000-0000-0000-0000-000000000000-1", label: "Standard User" },
    { cognitoId: "00000000-0000-0000-0000-000000000000-4", label: "Gold User" },
    { cognitoId: "00000000-0000-0000-0000-000000000000-2", label: "Diamond User" },
    { cognitoId: "00000000-0000-0000-0000-000000000000-3", label: "Admin User" },
];


interface TestUserLoginButtonsProps {
    redirectPathname: string | null;
}


export function TestUserLoginButtons({ redirectPathname }: TestUserLoginButtonsProps) {

    const buildLoginUrl = (cognitoId: string): string => {
        const params = new URLSearchParams({ cognito_id: cognitoId });
        if (redirectPathname) {
            params.set("redirect", redirectPathname);
        }
        return `/login/test?${params.toString()}`;
    };

    const buildSignupUrl = (): string => {
        if (!redirectPathname)
            return "/login/test/signup";

        const params = new URLSearchParams({ redirect: redirectPathname });
        return `/login/test/signup?${params.toString()}`;
    };

    return (
        <>
            {testUsers.map(user => (
                <Button
                    size="lg"
                    key={user.cognitoId}
                    href={buildLoginUrl(user.cognitoId)}
                    prefetch={false}
                    className="w-full mt-3">

                    {user.label}
                </Button>
            ))}
            <Button
                size="lg"
                href={buildSignupUrl()}
                prefetch={false}
                className="w-full mt-3">

                Create New Test Account
            </Button>
        </>
    );
}
